export default __webpack_public_path__ + "static/media/sd-nv-horizontal.534637c2.svg";